import { render, staticRenderFns } from "./DrawerHeader.vue?vue&type=template&id=391c0a4a&scoped=true"
import script from "./DrawerHeader.vue?vue&type=script&lang=js"
export * from "./DrawerHeader.vue?vue&type=script&lang=js"
import style0 from "./DrawerHeader.vue?vue&type=style&index=0&id=391c0a4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391c0a4a",
  null
  
)

export default component.exports